import type { Catalog } from "../../en";

/** Filipino: platform admin plans & pricing screen (mirrors en). */
export const plans: Catalog["adminScreens"]["plans"] = {
  title: "Mga plan at presyo",
  subtitle: "Mga limit ng plan, price book bawat currency (PHP, USD), add-on, coupon, tax rule at payment gateway. Hindi kasama ang buwis sa presyo (idinadagdag ang 12% VAT sa PH; zero-rated sa ibang bansa).",
  cycle: { label: "Billing cycle", monthly: "Buwanan", annual: "Taunan (−17%)" },
  previewPricing: "I-preview ang pricing page",
  newPlan: "Bagong plan",
  emptyTitle: "Wala pang plan",
  emptyBody: "Gumawa ng unang plan para makapagbenta ng mga workspace.",
  card: {
    pricesCaption: "Presyo ng {{plan}} bawat currency",
    nextPrice: "{{price}} mula {{date}}",
    addPrice: "Magdagdag ng presyo",
    addPriceLabel: "Magdagdag ng presyo para sa {{plan}}",
    subs_one: "{{count}} sub",
    subs_other: "{{count}} sub",
    popular: "Pinakasikat",
    draft: "Draft · nakatago",
    custom: "Custom",
    customMonthly: " · ayon sa kontrata",
    customAnnual: " · taunang kontrata",
    messages: "Mensahe",
    agents: "Agent",
    storage: "Storage",
    seats: "Seat",
    fileSize: "Laki ng file",
    models: "Model",
    mb: "{{value}} MB",
    featuresLabel: "Mga feature ng {{plan}}",
    featureOn: "{{feature}} sa {{plan}}",
    featureAdded: "Naidagdag ang {{feature}} sa {{plan}}",
    featureRemoved: "Inalis ang {{feature}} sa {{plan}}",
    edit: "I-edit ang plan",
    editLabel: "I-edit ang plan na {{plan}}",
    subscribers: "Mga subscriber",
    subscribersOf: "Mga subscriber ng {{plan}}",
  },
  tiers: { standard: "Standard", premium: "Premium", standardHint: "Mabilis at murang chat model", premiumHint: "Pinakamataas na kalidad na chat model" },
  features: {
    widget: "Website widget",
    webapp: "Web app + custom domain",
    messenger: "Messenger channel",
    api: "API access",
    actions: "Actions (booking, webhooks)",
    helpdesk: "Helpdesk at handoff",
    mobile_white_label: "White-label na mobile app",
    sso: "SSO / audience gating",
    evaluations: "Evaluations",
    remove_branding: "Kasama ang pag-alis ng branding",
    custom_roles: "Custom na role",
    private_deployment: "Private / on-prem deployment",
    sla: "99.9% SLA + DPA",
    customer_success_manager: "Customer success manager",
    after_sales: "After-sales (asset, pagbisita, RMA)",
    commerce: "Katalogo at mga order",
    commerce_presets: "Mga preset ng vendor connector",
    connectors: "Mga API connector",
    graph_retrieval: "Knowledge graph (Experiment)",
    secure_launch: "Secure launch (naka-sign-in na chat)",
    secure_launch_facts: "Customer facts ng Secure launch",
  },
  editor: {
    saved: "Na-save ang {{plan}}",
    pricesHint: "Nasa price book ang mga presyo: gamitin ang “Magdagdag ng presyo” sa plan card (bawat currency, may grandfathering).",
    editTitle: "I-edit ang plan · {{plan}}",
    newTitle: "Bagong plan",
    subscribers_one: "{{count}} aktibong subscriber",
    subscribers_other: "{{count}} aktibong subscriber",
    newDescription: "Mase-save bilang draft at nakatago sa pricing page hanggang i-publish mo.",
    name: "Pangalan ng plan",
    key: "Plan key",
    keyHint: "Lowercase na identifier na gamit sa API at billing; hindi na ito mababago.",
    keyInvalid: "Gumamit ng 2–64 lowercase na letra, numero, tuldok o underscore, nagsisimula sa letra.",
    nameRequired: "Lagyan ng pangalan ang plan (hanggang 200 character).",
    tagline: "Tagline",
    limits: "Mga limit",
    unlimitedPlaceholder: "Walang limit",
    messages: "Mensahe / buwan",
    agents: "Agent",
    storage: "Storage (MB)",
    seats: "Seat",
    fileSize: "Pinakamalaking file (MB)",
    rateLimit: "Rate limit (req/min)",
    invalidLimit: "Maglagay ng buong numero o iwanang blangko para walang limit.",
    invalidFile: "Maglagay ng buong numero mula 1 hanggang {{max}}.",
    models: "Pinapayagang model tier",
    tiersRequired: "Pumili ng kahit isang model tier.",
    features: "Mga feature",
    visibility: "Pricing page",
    popular: "Markahan bilang “Pinakasikat”",
    visible: "Ipakita sa pricing page",
    save: "I-save ang plan",
    create: "Gumawa ng plan",
    created: "Nagawa ang plan na {{plan}} (draft — nakatago sa pricing page)",
  },
  addons: {
    noPrice: "Wala pang presyo",
    addPrice: "Magdagdag ng presyo para sa {{addon}}",
    title: "Mga add-on",
    subtitle: "Ibinebenta kasama ng anumang bayad na plan",
    add: "Add-on",
    colAddon: "Add-on",
    colType: "Uri",
    colPrice: "Presyo",
    colAvailable: "Available sa",
    colStatus: "Status",
    colActions: "Mga aksyon",
    types: { recurring: "Paulit-ulit", one_time: "Isang beses", setup_fee: "Setup fee" },
    pricePerMonth: "{{price}}/buwan",
    priceSetup: "{{price}} setup",
    credits: "+{{count}} message credit",
    allPlans: "Lahat ng plan",
    noPlans: "Walang plan",
    statusLabel: "Ipakita ang {{addon}} sa checkout",
    shown: "Ipinapakita na ang {{addon}} sa checkout",
    hidden: "Nakatago na ang {{addon}} sa checkout",
    edit: "I-edit ang {{addon}}",
    emptyTitle: "Wala pang add-on",
    emptyBody: "Sa add-on, makakabili ang tenant ng dagdag na mensahe, agent o seat bukod sa plan nila.",
  },
  addonDialog: {
    pricesHint: "Itakda ang presyo bawat currency gamit ang price button sa talaan ng add-on.",
    newTitle: "Bagong add-on",
    editTitle: "I-edit ang add-on",
    name: "Pangalan",
    namePlaceholder: "hal. Priority support (4 na oras na tugon)",
    nameRequired: "Lagyan ng pangalan ang add-on.",
    description: "Paglalarawan",
    descriptionPlaceholder: "Ipinapakita sa ilalim ng pangalan sa checkout",
    billing: "Billing",
    billingTypes: { recurring: "Buwanang paulit-ulit", one_time: "Isang beses", setup_fee: "Setup fee" },
    credits: "Message credit",
    creditsHint: "Opsyonal: credit na idinadagdag sa bawat bili.",
    creditsInvalid: "Maglagay ng buong numero o iwanang blangko.",
    available: "Available sa",
    availableRequired: "Pumili ng kahit isang plan.",
    save: "I-save ang add-on",
    saved: "Na-save ang add-on",
  },
  priceDialog: {
    title: "Bagong presyo · {{item}}",
    body: "Hindi binabago ang presyo: magsisimula ang bagong row sa petsa nito. Hindi nagbabago ang presyo ng mga naibigay nang invoice.",
    currency: "Currency",
    interval: "Interval ng billing",
    amount: "Halaga (bago ang buwis)",
    amountInvalid: "Maglagay ng halaga na may hanggang 2 decimal.",
    effectiveFrom: "Epektibo mula",
    effectiveHint: "Ngayon o sa susunod na araw.",
    dateInvalid: "Pumili ng petsa ngayon o pagkatapos.",
    grandfather: "I-grandfather ang kasalukuyang subscriber",
    grandfatherOn: "Mananatili sa kasalukuyang presyo ang {{count}} subscriber ng plan, currency at interval na ito hanggang magpalit sila ng plan.",
    grandfatherOff: "Lilipat sa presyong ito ang {{count}} subscriber ng plan, currency at interval na ito sa susunod nilang renewal.",
    save: "Idagdag ang presyo",
    saved: "Nadagdag ang bagong presyo para sa {{item}}",
    savedGrandfathered_one: "Nadagdag ang {{price}} para sa {{item}} · {{count}} subscriber ang mananatili sa lumang presyo",
    savedGrandfathered_other: "Nadagdag ang {{price}} para sa {{item}} · {{count}} subscriber ang mananatili sa lumang presyo",
    savedMoving_one: "Nadagdag ang {{price}} para sa {{item}} · {{count}} subscriber ang lilipat sa susunod na renewal",
    savedMoving_other: "Nadagdag ang {{price}} para sa {{item}} · {{count}} subscriber ang lilipat sa susunod na renewal",
  },
  tax: {
    title: "Mga tax rule",
    subtitle: "Bawat bansa ng billing; ang pinakabagong rule mula sa petsa nito ang ginagamit sa bagong invoice.",
    country: "Bansa",
    countryHint: "ISO code, o * para sa lahat ng ibang bansa",
    countryInvalid: "Gumamit ng 2-letrang country code o *.",
    mode: "Pagtrato",
    modes: { exclusive: "Idinadagdag", inclusive: "Kasama na sa presyo", zero_rated: "Zero-rated (0%)", exempt: "Exempt" },
    rate: "Rate (%)",
    rateInvalid: "Maglagay ng porsyentong mas mababa sa 100.",
    label: "Label sa invoice",
    labelRequired: "Bigyan ng label sa invoice ang rule.",
    note: "Tala sa invoice",
    add: "Idagdag ang rule",
    saved: "Nadagdag ang tax rule para sa {{country}}",
    everyOther: "Lahat ng ibang bansa",
  },
  coupons: {
    title: "Mga coupon",
    create: "Gumawa ng coupon",
    colCode: "Code",
    colDiscount: "Diskwento",
    colUses: "Gamit",
    colExpires: "Mag-e-expire",
    colStatus: "Status",
    colActions: "Mga aksyon",
    copy: "Kopyahin ang code na {{code}}",
    copied: "Nakopya ang coupon code",
    discount: { pct: "{{value}}% bawas", fixed: "{{value}} bawas", trial_days: "+{{value}} araw ng trial" },
    durations: { once: "isang beses", "3m": "× 3 buwan", "6m": "× 6 na buwan", forever: "habambuhay", annual: "taunan" },
    uses: "{{used}} / {{max}}",
    states: { active: "Aktibo", expired: "Expired", disabled: "Naka-disable", used_up: "Ubos na" },
    disable: "I-disable",
    disableLabel: "I-disable ang coupon na {{code}}",
    disabledToast: "Na-disable ang coupon na {{code}}",
    emptyTitle: "Wala pang coupon",
    emptyBody: "Gumawa ng code para sa campaign, partner o pilot na diskwento.",
  },
  couponDialog: {
    currency: "Currency",
    currencyHint: "Sa invoice lang na nasa currency na ito gagamitin ang fixed na halaga.",
    title: "Gumawa ng coupon",
    code: "Code",
    codeInvalid: "Gumamit ng 3–40 letra, numero, gitling o underscore.",
    generate: "Gumawa",
    type: "Uri",
    types: { pct: "Porsyentong bawas", fixed: "Tiyak na halaga", trial_days: "Dagdag na araw ng trial" },
    value: "Halaga",
    valueInvalid: "Maglagay ng halagang higit sa 0.",
    pctInvalid: "Hindi puwedeng lumampas sa 100 ang porsyento.",
    duration: "Tagal",
    durations: { once: "Isang beses", "3m": "3 buwan", "6m": "6 na buwan", forever: "Habambuhay", annual: "Taunang billing" },
    max: "Max na redemption",
    maxPlaceholder: "Walang limit",
    maxInvalid: "Maglagay ng buong numero na hindi bababa sa 1, o iwanang blangko.",
    expires: "Mag-e-expire",
    appliesTo: "Para sa",
    allPlans: "Lahat ng plan",
    newOnly: "Bagong customer lang",
    submit: "Gumawa ng coupon",
    created: "Nagawa ang coupon na {{code}}",
  },
  gateways: {
    paypal: "PayPal",
    currencies: "Tumatanggap ng {{currencies}}",
    adapterModes: { live: "Live", test: "Test mode", mock: "Mock (walang key)", unconfigured: "Hindi naka-configure" },
    publicKeyOf: "Public identifier ng {{gateway}}",
    secretOk: "Naka-configure ang secret key",
    secretMissing: "Walang secret key",
    env: "Environment: {{env}}",
    title: "Payment gateway at resibo",
    subtitle: "Mga paraan ng bayad na nakikita ng tenant at BIR-compliant na OR numbering",
    settingsLink: "Platform settings",
    connected: "Nakakonekta",
    notConfigured: "Hindi pa naka-configure",
    paymongo: "PayMongo",
    paymongoMeta: "PHP · pangunahin · {{mode}} mode",
    modes: { live: "live", test: "test" },
    methodsLabel: "Mga paraan ng bayad sa PayMongo",
    methods: { gcash: "GCash", maya: "Maya", cards: "Card (Visa / Mastercard)", online_banking: "Online banking (BPI, UnionBank)" },
    methodOn: "Naka-enable ang {{method}}",
    methodOff: "Nakatago ang {{method}} sa checkout",
    publicKey: "PayMongo public key",
    keyMissing: "Walang naka-configure na public key",
    webhookOk: "Naka-configure ang webhook secret",
    webhookMissing: "Walang webhook secret",
    stripe: "Stripe",
    stripeMeta: "USD · card checkout",
    lockFx: "I-lock ang FX rate buwan-buwan",
    lockOn: "Naka-lock buwan-buwan ang FX rate",
    lockOff: "Sumusunod ang FX rate sa araw-araw na BSP reference",
  },
  orSeries: {
    title: "BIR official receipt",
    prefix: "OR prefix",
    prefixInvalid: "1–12 uppercase na letra, numero o gitling.",
    next: "Susunod na numero",
    start: "Simula ng serye",
    end: "Dulo ng serye",
    numberInvalid: "Maglagay ng buong numero na hindi bababa sa 1.",
    rangeInvalid: "Dapat mas mataas ang dulo kaysa sa simula ng serye.",
    nextInvalid: "Dapat nasa loob ng serye ang susunod na numero.",
    atp: "ATP / CAS permit no.",
    registrantName: "Rehistradong pangalan",
    registrantTin: "TIN",
    registrantAddress: "Rehistradong address",
    remaining_one: "{{count}} resibo na lang ang natitira.",
    remaining_other: "{{count}} resibo pa ang natitira.",
    registeredTo: "Rehistrado sa {{line}}.",
    none: "Wala pang serye ng resibo — mag-set up muna bago mag-isyu ng official receipt.",
    save: "I-save ang serye",
    create: "Gumawa ng serye",
    saved: "Na-save ang serye ng BIR receipt",
  },
};
